import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    height: '100%',
  },
  form: {
    width: '100%',
  },
  spinnerWrapper: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  panel: {
    backgroundColor: palette.background.default,
    height: '72px',
    top: 'auto',
    right: 'auto',
    left: 'auto',
    bottom: 0,
    justifyContent: 'start',
    flexDirection: 'row',
    // zIndex: 2147483100,
    boxShadow: 'none',
    [breakpoints.up('lg')]: {
      // paddingLeft: 210,
    },
  },
  panelFixed: {
    borderTop: '1px solid #DCDEE5',
    // paddingLeft: 16,

    [breakpoints.up('lg')]: {
      // paddingLeft: 'calc((100% - 1280px) / 2 + 224px)',
    },
  },
  panelForVideoMenu: {
    [breakpoints.up('lg')]: {
      left: 212,
    },
  },
  panelButton: {
    height: '36px',
    minWidth: '128px',

    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
  },
  toolbar: {
    padding: 0,
    justifyContent: 'start',
    width: '100%',
    maxWidth: '960px',
    [breakpoints.down('lg')]: {
      maxWidth: '100%',
      paddingLeft: 0,
    },
    '& button:first-child': {
      marginRight: 16,
    },
  },
  buttonIcon: {
    width: '18px',
    height: '18px',
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
  },
  backLine: {
    height: 72,
    width: '100%',
    top: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    position: 'fixed',
    borderTop: '1px solid #DCDEE5',
  },
  cancelButton: palette.cancelAction,
}), { name: 'ItemForm' });

export default useStyles;
